<template>
  <div class="fixed-header">
      <!-- 在这里放置 header 的内容，比如 logo、导航链接等 -->
      <div class="logo"><img :src="headImg" alt="Company Logo"></div>
      <nav class="nav-links">
        <ul>
          <li v-for="(item, index) in items" :key="index">
            <a :class="{ selected: item.selected }" @click="selectItem(index)" :href="item.href">
              {{ item.text }}
            </a>
          </li>
        </ul>
      </nav>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      headImg: require("@/assets/img/logo.png"),
      items: [
        { text: '首页', selected: false, href:  '/' },
        { text: '我们的服务', selected: false, href:  '/home#weServe'},
        { text: '关于我们', selected: false, href:  '/home#weAbout'},
        { text: '联系我们', selected: false, href:  '/home#weContact'},
      ]
    }
  },
  methods: {
    selectItem(index) {
      // 清除所有链接的选中状态
      this.items = this.items.map(item => ({ ...item, selected: false }));
      // 设置当前链接的选中状态
      this.items[index].selected = true;
    }
  },
};
</script>

<style scoped>

.logo {
  width: 625px;
  height: 80px;
  padding-left: 15%;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

img {
  width: 600px;
  height: 50px;
  position: relative;
  top: 50%; /* 将内容的顶部设置在容器的中心 */
  left: 50%; /* 将内容的左边设置在容器的中心 */
  transform: translate(-50%, -50%); /* 使用变换将内容自身的中心移动到之前设置的中心点上 */
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px; /* 你可以根据需要调整 header 的高度 */
  background-color: #fff; /* 你可以设置 header 的背景色 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 添加阴影效果，让 header 看起来悬浮在页面上 */
  z-index: 999; /* 确保 header 显示在页面的最上层 */
  display: flex;
  align-items: center; /* 垂直居中 header 中的内容 */
  justify-content: space-between; /* 水平布局 header 中的内容 */
  padding: 0; /* 添加内边距，防止内容贴近边缘 */
}


.nav-links {
  padding-right: 15%;
}


.nav-links ul {
  list-style: none; /* 移除列表的默认样式 */
  //margin: 0;
  padding: 0;
  display: flex;
}

.nav-links ul li {
  flex-shrink: 1; /* 允许元素缩小 */
  white-space: nowrap; /* 防止文本换行 */
  //border-left: 1px solid rgba(0, 0, 0, 0.3);
  padding-left: 50px;
  margin-left: 15px; /* 设置导航链接之间的间距 */
}

.nav-links ul li a {
  text-decoration: none; /* 移除链接的下划线 */
  color: #333; /* 设置链接的文字颜色 */
  font-size: 16px;
}

.nav-links ul li a:hover {
  color: #974576; /* 鼠标悬停时的字体颜色 */
}

/* 选中状态样式 */
.nav-links ul li a.selected {
  color: #f2af00; /* 选中时的字体颜色 */
}

</style>
